import { useState, useEffect, useRef } from 'react';

const LOCAL_IMAGE = 'https://public.readdy.ai/ai/img_res/9641c852020c02d583d5ceab53a3888a.jpg';

export default function LocalSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="local" className="relative overflow-hidden" ref={ref}>
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={LOCAL_IMAGE}
          alt="West Texas sunset landscape"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2D3E2E]/70 via-[#1A2A1A]/60 to-[#2D3E2E]/70" />
      </div>

      {/* Content */}
      <div
        className={`relative z-10 max-w-4xl mx-auto px-6 md:px-12 py-28 md:py-40 text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <span
          className="inline-block text-xs font-semibold tracking-widest uppercase text-[#E8C4A8] mb-6 border border-[#E8C4A8]/40 px-5 py-2 rounded-full"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Lubbock, Texas
        </span>

        <h2
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
          style={{ fontFamily: '\'Playfair Display\', serif', textShadow: '0 2px 12px rgba(0,0,0,0.3)' }}
        >
          Proudly Based in Lubbock, Texas
        </h2>

        <p
          className="text-xl text-white/85 leading-relaxed mb-6"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          At Brand New You, we believe in grit, growth, and fresh starts. Rooted in Lubbock, Texas,
          we are passionate about helping people in our community step into a stronger future with
          courage and clarity.
        </p>

        <p
          className="text-lg text-white/75 leading-relaxed mb-12"
          style={{ fontFamily: '\'Playfair Display\', serif', fontStyle: 'italic' }}
        >
          Whether you feel stuck, uncertain, or simply ready for more — your next chapter can start today.
        </p>

        <button
          onClick={() => scrollTo('consultation')}
          className="inline-block bg-white text-[#2D3E2E] px-10 py-4 rounded-full text-base font-semibold hover:bg-[#D4896A] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:-translate-y-0.5"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Schedule Your Free Consultation
        </button>
      </div>
    </section>
  );
}
